module.exports = __webpack_public_path__ + "static/1b-1c859f20f2e224514c45eba2ac4ecc6e.webp";